import {
  CcfBox,
  CcfNoneFoundIcon,
  CcfSearchIcon,
  CcfTextField,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './ccf-wem-dashboard.module.scss';
import { InputAdornment } from '@mui/material';
import { makeStyles } from '@mui/styles';

/* eslint-disable-next-line */
export interface CcfWemCoachingProps {}

const useStyles = makeStyles({
  searchInput: {
    '&.MuiOutlinedInput-input': {
      color: '#000000',
      border: '0',
      outline: '0',
      fontSize: '14px',
    },
  },
});

/**
 * CcfWemCoaching - used to display wem coaching
 * @param props - CcfWemCoaching
 * @example `<CcfWemCoaching />`
 */
export function CcfWemCoaching(props: CcfWemCoachingProps) {
  const classes = useStyles();
  return (
    <CcfBox className={styles.wemScheduleContainer}>
      <CcfBox>
        <CcfTypography className={styles.wemTabTitle}>Coaching</CcfTypography>
      </CcfBox>
      <CcfBox className={styles.searchBar}>
        <CcfBox className={styles.searchCountText}>0 coachings</CcfBox>
        <CcfBox>
          <CcfTextField
            id="search Box"
            size="small"
            className={styles.coachingSearchBox}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CcfSearchIcon htmlColor="grey" />
                </InputAdornment>
              ),
              classes: { input: classes.searchInput },
            }}
            placeholder="Start typing to find plan"
          />
        </CcfBox>
      </CcfBox>
      <CcfBox className={styles.noResultFoundBlock}>
        <CcfNoneFoundIcon style={{ fontSize: 240 }} />
        <CcfTypography className={styles.noResultTxt}>
          We didn't find any results
        </CcfTypography>
      </CcfBox>
    </CcfBox>
  );
}
